export { LINK_SYSTEM_PRODUCTS_PT_BR } from "./link-system-products-pt-br";
export { LINK_SYSTEM_PRODUCTS_EN_US } from "./link-system-products-en-us";
export { LINK_SYSTEM_PRODUCTS_ES_ES } from "./link-system-products-es-es";
export { LINK_SYSTEM_PRODUCTS_ES_MX } from "./link-system-products-es-mx";
export { LINK_SYSTEM_PRODUCTS_FR_FR } from "./link-system-products-fr-fr";
export type { linkSystemProductsTranslations } from "./link-system-products-pt-br";
